<template>
  <div>
    <section>
      <v-app-bar
        :clipped-left="clipped"
        color="#F9F9F9"
        fixed
        nav
        elevation="0"
        app
        style="z-index: 6;">
        <v-app-bar-nav-icon class="hidden-lg-and-up" @click.stop="drawer = !drawer"/>
        
        <v-toolbar-title 
          class="body-2 font-weight-bold black--text text-capitalize d-flex align-center"
          :class="clipped ? 'pl-16 ml-2' : ''">
          <span
            style="opacity: 40%;">
            {{ Object.keys(company).length > 0 ? company.company_name : 'PT Amanata' }}
          </span>

          <v-icon size="20" class="mx-2" color="#959595">mdi-chevron-double-right</v-icon>

          <span
            class="black--text">
            {{ $route.name }}
          </span>
        </v-toolbar-title>

        <v-spacer/>

        <!-- <v-menu
          close-on-content-click 
          nudge-width="250" 
          offset-x>
          <template v-slot:activator="{ on }">
            <div v-on="on" 
              class="cursor-pointer">
              <v-badge v-if="total > 0"
                color="red"
                overlap>
                <span v-if="total > 9"
                  slot="badge">
                  9+
                </span>

                <span slot="badge" v-else>
                  {{ total }}
                </span>
                
                <span slot="default">
                  <v-icon color="orange">mdi-bell</v-icon>
                </span>
              </v-badge>

              <span v-else
                slot="default">
                <v-icon color="grey">mdi-bell</v-icon>
              </span>
            </div>
          </template>
        </v-menu>

        <v-text-field
          class="no_box ml-4"
          solo
          :color="set_color"
          placeholder="Cari"
          
          hide-details
          
          style="max-width: 300px">
        </v-text-field> -->

        <v-menu
          transition="slide-x-transition"
          bottom
          right
          offset-y>
          <template v-slot:activator="{ on, attrs }">
            <v-list 
              flat 
              class="ml-4"
              color="transparent">
              <v-list-item 
                v-bind="attrs"
                v-on="on"
                class="px-2"
                style="border-radius: 10px; background: #FFFFFF;">
                <v-list-item-avatar 
                  size="30"
                  tile
                  style="border-radius: 5px !important;">
                  <v-img 
                    width="100%"
                    height="auto"
                    alt="umb" 
                    :src="user.image_url === '' ? require('@/assets/image/member_default.jpg') : user.image_url"
                    class="ma-auto">
                    <template v-slot:placeholder>
                      <v-row
                        class="fill-height"
                        align="center"
                        justify="center">
                        <v-progress-circular 
                          size="20"
                          indeterminate 
                          :color="set_color">
                        </v-progress-circular>
                      </v-row>
                    </template>
                  </v-img>
                </v-list-item-avatar>

                <v-list-item-content>
                  <v-list-item-title
                    class="body-2">
                    {{ user.name }}
                  </v-list-item-title>
                </v-list-item-content>

                <v-list-item-action>
                  <v-icon>mdi-menu-down</v-icon>
                </v-list-item-action>
              </v-list-item>
            </v-list>
          </template>

          <v-list>
            <v-list-item
              v-for="(item, index) in menu.right"
              :key="index"
              @click="toMenu(item)">
              <v-list-item-content
                :style="index < menu.right.length - 1 ? 'border-bottom: 2px solid #f9f9f9;' : ''">
                <v-list-item-title>
                  {{ item.title }}
                </v-list-item-title>
              </v-list-item-content>

            </v-list-item>
          </v-list>
        </v-menu>
      </v-app-bar>

      <v-navigation-drawer
        v-model="drawer"
        :mini-variant.sync="clipped"
        width="275"
        color="#F9F9F9"
        dark
        fixed
        app>
        <div
          class="d-flex align-center cursor-pointer pa-3 py-1 mb-6"
          style="height: 64px;">
          <div
            class="d-flex align-center">
            <!-- <v-img 
              contain
              :width="!clipped ? 36 : 30"
              :height="!clipped ? 36 : 30"
              alt="umb" 
              :src="Object.keys(company).length > 0 ? company.fav_icon : require('@/assets/logo/favicon.svg')"
              class="ma-auto">
              <template v-slot:placeholder>
                <v-row
                  class="fill-height"
                  align="center"
                  justify="center">
                  <v-progress-circular 
                    size="20"
                    indeterminate 
                    :color="set_color">
                  </v-progress-circular>
                </v-row>
              </template>
            </v-img>

            <div v-if="!clipped"
              class="text-h5 font-weight-bold text-center one-line ml-2"
              :style="`color: ${set_color};`">
              {{ Object.keys(company).length > 0 ? company.company_name : 'amanata' }}
            </div>

            <v-spacer />

            <v-btn v-if="!clipped"
              @click="clipped = !clipped ? true : false"
              class="mr-3"
              style="position: absolute; right: 0;"
              icon>
              <v-icon
                color="black">
                mdi-chevron-left
              </v-icon>
            </v-btn> -->

            <v-img v-if="clipped"
              contain
              width="30"
              height="30"
              alt="umb" 
              :src="Object.keys(company).length > 0 ? company.fav_icon : require('@/assets/logo/favicon.svg')"
              class="ma-auto">
              <template v-slot:placeholder>
                <v-row
                  class="fill-height"
                  align="center"
                  justify="center">
                  <v-progress-circular 
                    size="20"
                    indeterminate 
                    :color="set_color">
                  </v-progress-circular>
                </v-row>
              </template>
            </v-img>

            <v-img v-if="!clipped"
              contain
              width="100"
              height="auto"
              alt="umb" 
              :src="Object.keys(company).length > 0 ? company.logo : require('@/assets/logo/favicon.svg')"
              class="ma-auto">
              <template v-slot:placeholder>
                <v-row
                  class="fill-height"
                  align="center"
                  justify="center">
                  <v-progress-circular 
                    size="20"
                    indeterminate 
                    :color="set_color">
                  </v-progress-circular>
                </v-row>
              </template>
            </v-img>

            <v-spacer v-if="!clipped" />

            <v-btn v-if="!clipped"
              @click="clipped = !clipped ? true : false"
              class="mr-3"
              style="position: absolute; right: 0;"
              icon>
              <v-icon
                color="black">
                mdi-chevron-left
              </v-icon>
            </v-btn>
          </div>
        </div>

        <v-list>
          <div 
            v-for="(item, index) in menu.left"
            :key="index">
            <v-list-item 
              v-if="item.sub_menu.length < 1"
              :to="item.link" 
              color="transparent">
              <v-list-item-avatar
                size="22"
                tile
                class="mr-4">
                <v-icon
                  size="22"
                  :color="item.link === $route.fullPath ? set_color : '#959595'">
                  {{ item.icon }}
                </v-icon>
              </v-list-item-avatar>

              <v-list-item-content>
                <v-list-item-title
                  class="body-2"
                  :class="item.link === $route.fullPath ? 'font-weight-bold' : 'grey--text'"
                  :style="item.link === $route.fullPath ? `color: ${set_color};` : ''">
                  {{ item.title }}
                </v-list-item-title>
              </v-list-item-content>
            </v-list-item>

            <div v-else>
              <v-list-group
                v-model="item.active"
                :color="set_color"
                :append-icon="item.sub_menu.length > 0 ? 'mdi-menu-down' : ''"
                no-action>
                <template v-slot:activator>
                  <v-list-item-avatar
                    size="22"
                    tile
                    class="mr-4">
                    <v-icon
                      size="22"
                      :color="item.active ? set_color : '#959595'">
                      {{ item.icon }}
                    </v-icon>
                  </v-list-item-avatar>

                  <v-list-item-content>
                    <v-list-item-title
                      class="body-2"
                      :class="item.active ? 'font-weight-bold' : 'grey--text'"
                      :style="item.active === $route.fullPath ? `color: ${set_color};` : ''">
                      {{ item.title }}
                    </v-list-item-title>
                  </v-list-item-content>
                </template>

                <div
                  v-for="(item_sub, index_sub) in item.sub_menu"
                  :key="index_sub">
                  <v-list-item
                    v-if="item_sub.sub_child.length < 1"
                    :to="item_sub.link"
                    class="pl-14"
                    color="transparent">
                    <v-list-item-content>
                      <v-list-item-title
                        class="body-2"
                        :class="item_sub.link === $route.fullPath ? 'font-weight-bold' : 'grey--text'"
                        :style="item_sub.link === $route.fullPath ? `color: ${set_color};` : ''">
                        {{ item_sub.title }}
                      </v-list-item-title>
                    </v-list-item-content>
                  </v-list-item>

                  <div v-else>
                    <v-list-group
                      v-model="item_sub.active"
                      :color="set_color"
                      :append-icon="item_sub.sub_child.length > 0 ? 'mdi-menu-down' : ''"
                      no-action
                      sub-group
                      class="sub_child">
                      <template v-slot:activator>
                        <v-list-item-content>
                          <v-list-item-title
                            class="body-2"
                            :class="item_sub.active ? 'font-weight-bold' : 'grey--text'"
                            :style="item_sub.active === $route.fullPath ? `color: ${set_color};` : ''"
                            style="padding-left: 23px;">
                            {{ item_sub.title }}
                          </v-list-item-title>
                        </v-list-item-content>
                      </template>

                      <div
                        v-for="(item_child, index_child) in item_sub.sub_child"
                        :key="index_child">
                        <v-list-item
                          :to="item_child.link"
                          color="transparent"
                          class="pl-5"
                          style="margin-left: 57px;"
                          :style="item_child.link !== $route.path ?  `border-left: 1px solid #e0e0e0;` : `border-left: 2px solid ${set_color};`">
                          <v-list-item-content>
                            <v-list-item-title
                              class="body-2"
                              :class="item_child.link === $route.path ? 'font-weight-bold' : 'grey--text'"
                              :style="item_child.link === $route.path ? `color: ${set_color};` : ''">
                              {{ item_child.title }}
                            </v-list-item-title>
                          </v-list-item-content>
                        </v-list-item>
                      </div>
                    </v-list-group>
                  </div>
                </div>
              </v-list-group>
            </div>

            <!-- <v-list-group
              v-else
              v-model="item.active"
              :color="set_color"
              :append-icon="item.sub_menu.length > 0 ? 'mdi-menu-down' : ''"
              no-action>
              <template v-slot:activator>
                <v-list-item-avatar
                  size="22"
                  tile
                  class="mr-4">
                  <v-icon
                    size="22"
                    :color="item.active ? set_color : '#959595'">
                    {{ item.icon }}
                  </v-icon>
                </v-list-item-avatar>

                <v-list-item-content>
                  <v-list-item-title
                    class="body-2"
                    :class="item.active ? 'font-weight-bold' : 'grey--text'"
                    :style="item.active === $route.fullPath ? `color: ${set_color};` : ''">
                    {{ item.title }}
                  </v-list-item-title>
                </v-list-item-content>
              </template>

              <v-list-item
                v-for="(item_sub, index_sub) in item.sub_menu"
                :key="index_sub"
                :to="item_sub.link"
                class="pl-15"
                color="transparent">
                <v-list-item-content>
                  <v-list-item-title
                    class="body-2"
                    :class="item_sub.link === $route.fullPath ? 'font-weight-bold' : 'grey--text'"
                    :style="item_sub.link === $route.fullPath ? `color: ${set_color};` : ''">
                    {{ item_sub.title }}
                  </v-list-item-title>
                </v-list-item-content>
              </v-list-item>
            </v-list-group> -->
          </div>
        </v-list>
      </v-navigation-drawer>
    </section>
  </div>
</template>

<script>
  import { TokenService } from "@/service/Storage.Service";
  import { get, post, put, destroy } from "@/service/Axios";
  export default {
    data () {
      return {
        clipped: false,
        drawer: true,
        total: 0,
        menu: {
          right: [
            {
              title: 'Profil',
              type: 'profile',
              link: '/profile'
            },
            {
              title: 'Keluar',
              type: 'logout',
              link: '#'
            }
          ],
          left: []
        }
      }
    },
    components: {
      Empty: () => import(/* webpackPrefetch: true */ '@/components/empty')
    },
    computed: {
      user () {
        return this.$store.state.user
      },
      token () {
        return this.$store.state.token
      },
      reload () {
        return this.$store.state.reload
      },
      company () {
        return this.$store.state.company
      },
      set_color () {
        return this.$store.state.color
      },
      set_color_rgb_up () {
        let [r, g, b] = this.$store.state.color.match(/\w\w/g).map(x => parseInt(x, 16))

        return `rgba(${r+93}, ${g+120}, ${b+12})`
      }
    },
    created () {
      
    },
    mounted () {
      const debounce = (fn) => {
        let frame;
        return (...params) => {
          if (frame) { 
            cancelAnimationFrame(frame)
          }
          frame = requestAnimationFrame(() => {
            fn(...params)
          })
        } 
      }

      const storeScroll = () => {
        document.documentElement.dataset.scroll = window.scrollY
      }

      document.addEventListener('scroll', debounce(storeScroll), { passive: true })
      storeScroll()

      this.menu.left = this.$store.state.menu

      this.fetch()
    },
    methods: {
      async fetch () {
        await get('config')
        .then(response => {
          let res = response.data
            
          if (res.status === 200) {
            res.results.data[0].color = JSON.parse(res.results.data[0].color)

            TokenService.saveCompany(JSON.stringify(res.results.data[0]))

            this.$store.commit("setCompany", res.results.data[0])
            
            if (res.results.data[0].color.length > 0) {
              res.results.data[0].color.map((obj) => {
                if (obj.active) {
                  TokenService.saveColor(obj.hex)

                  this.$store.commit("setColor", obj.hex)
                }
              })
            } else {
              TokenService.saveColor('#7550e1')

              this.$store.commit("setColor", '#7550e1')
            }

            this.styles()
          }
        })
      },
      async toMenu (item) {
        if (item.type === 'logout') {
          await post('admin/auth/logout', {
            data: {
              username: this.user.username
            }
          })
          .then(response => {
            let res = response.data

            if (res.status === 200) {
              TokenService.removeToken()
              
              window.location = '/'
            }
          })
        } else {
          this.$router.push('/profile')
        }
      },
      styles () {
        let style = document.createElement('style')
          
        // RESET STYLESHEET TO AUTO
        style.innerHTML = `
          .v-data-table table .v-data-table-header {
            color: white;
            background-color: ${this.set_color}; !important;
          }
          .v-data-table table > thead > tr > th {
            background: ${this.set_color};
          }

          .v-data-table table > tbody .v-data-table__selected .v-input--selection-controls__input {
            color: ${this.set_color};
          }
          .v-data-table table > tbody .v-input--selection-controls__input .v-icon {
            color: ${this.set_color};
          }

          ::-webkit-scrollbar-thumb{
            border-radius: 10px;
            background-color: ${this.set_color};
          }

          #iw-container .iw-title {
            font-family: 'Open Sans Condensed', sans-serif;
            font-size: 22px;
            font-weight: 400;
            padding: 10px;
            background-color: ${this.set_color};
            color: white;
            margin: 0;
            border-radius: 2px 2px 0 0;
          }

          .v-slide-group__prev .v-icon {
            color: ${this.set_color}; !important;
          }

          .v-slide-group__next .v-icon {
            color: ${this.set_color}; !important;
          }

          .table-grid table > thead > tr > th:nth-child(1) {
            left: 0; 
            z-index: 5;
            background: ${this.set_color};
          }

          .v-data-table table > tbody > tr:hover .text-start, table > tbody > tr:hover .text-center,  table > tbody > tr:hover .text-end {
            cursor: pointer;
            // background-color: ${this.set_color_rgb_up} !important;
            background-color: #E0E0E0 !important;
          }
          .v-data-table__selected .text-start, .v-data-table__selected .text-center, .v-data-table__selected .text-end {
            // background-color: ${this.set_color_rgb_up} !important;
            background-color: #E0E0E0 !important;
          }
        `

        // ADD TO APPENDCHILD
        document.head.appendChild(style)
      }
    }
  }
</script>

<style>
  .sub_child .v-list-group__header .v-list-item__icon {
    position: absolute;
    right: 0;
    top: -4px;
  }
</style>